import React from "react";

function LeafeIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8577_3799)">
        <path
          d="M16.6641 20.6797C16.6641 20.6797 10.1641 21.1797 6.66406 17.1797C3.16406 13.1797 3.16406 1.17969 3.16406 1.17969C3.16406 1.17969 15.1641 0.679688 19.1641 3.67969C23.1641 6.67969 22.1641 15.1797 22.1641 15.1797"
          stroke="#3CAF47"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.1641 21.1797C23.1641 21.1797 17.5741 16.9552 14.1641 13.1797M14.1641 13.1797C10.7541 9.40419 9.16406 5.67969 9.16406 5.67969M14.1641 13.1797L14.6641 6.67969M14.1641 13.1797L9.16406 12.6797"
          stroke="#3CAF47"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8577_3799">
          <rect width="25.6709" height="25.6709" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default LeafeIcon;
